module.exports = __webpack_public_path__ + "img/assessment.197d406d.svg";